<route lang="yaml">
meta:
  layout: blank
  action: read
  subject: AclDemo
  allowLoggedInOnly: false
</route>

<script setup>
import { storeToRefs } from 'pinia'
import AgentChat from '@core/components/AgentChat.vue'
import { useAppModeStore } from '@/stores'

const appModeStore = useAppModeStore()
const { mode: appMode } = storeToRefs(appModeStore)
</script>

<template>
  <AgentChat
    v-if="appMode !== 'restaurantAdmin'"
    page-mode
  />
  <div
    v-else
    class="d-flex flex-column align-center justify-center"
    style="min-height: 50vh; padding: var(--ds-space-6);"
  >
    <h2 class="text-h6 mb-2">
      RM AI is available in Member mode
    </h2>
    <p class="text-body-2 text-medium-emphasis">
      Switch to Member mode from the app bar to use RM AI.
    </p>
  </div>
</template>
